import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const homePageHeadingDefaultVariants = {}
const homePageHeadingCompoundVariants = []

const homePageHeadingSlotNames = [
  [
    "root",
    "home-page-heading__root"
  ],
  [
    "title",
    "home-page-heading__title"
  ],
  [
    "picture",
    "home-page-heading__picture"
  ],
  [
    "image",
    "home-page-heading__image"
  ]
]
const homePageHeadingSlotFns = /* @__PURE__ */ homePageHeadingSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, homePageHeadingDefaultVariants, getSlotCompoundVariant(homePageHeadingCompoundVariants, slotName))])

const homePageHeadingFn = memo((props = {}) => {
  return Object.fromEntries(homePageHeadingSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const homePageHeadingVariantKeys = []
const getVariantProps = (variants) => ({ ...homePageHeadingDefaultVariants, ...compact(variants) })

export const homePageHeading = /* @__PURE__ */ Object.assign(homePageHeadingFn, {
  __recipe__: false,
  __name__: 'homePageHeading',
  raw: (props) => props,
  variantKeys: homePageHeadingVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, homePageHeadingVariantKeys)
  },
  getVariantProps
})